import { Modal, Button } from 'react-bootstrap';
import { useState, useEffect, useContext } from 'react';
import { Input, TextArea, Select, TextAreaAdvanced, InputImageUploadSimple } from "../../../../../Layout/Forms/Form";
import Table from "../../../../../Layout/Table/Table";
import UserAccessManagerRequests from './UserAccessManagerRequests';
import ModalConfirmation from '../../../../../Layout/Modals/ModalConfirmation'
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UserAccessManagerModal from './UserAccessManagerFormModal';

function UserAccessManagerListModal({ show, id, handleModalhide, handleModalShow }) {

    // const [show, setShow] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState([]);
    const [refreshGrid, setRefreshGrid] = useState(0)
    const [nighspotID, setNightspotID] = useState(0);

    const columns = ['name', 'email', 'type', 'Actions'];
    const serializeRowsColums = () => {
        return !state ? null : state.map((item) => {
            return {
                ...item,
                Actions: <ActionColumn id={item.id} />,
            };
        })
    }

    const ActionColumn = ({ id }) => {
        return (
            <div>
                <div onClick={() => handlerDeleteUserAccessConfirmation(id)} className="btn btn-danger btn-sm"><i className="fa-solid fa-trash"></i>&nbsp; Delete</div>
            </div>
        )
    }

    const [modalConfirmationState, setModalConfirmationState] = useState({
        isVisible: false,
        param: 0
    })

    const handleShowModalConfirmation = (obj) => setModalConfirmationState({
        isVisible: true,
        param: obj
    })

    const handleHideModalConfirmation = () => setModalConfirmationState({
        isVisible: false,
        param: 0
    })

    const [formVenueMembers, setFormVenueMembers] = useState({
        isVisible: false,
        form: {

        }
    })

    const handleModalShowFormVenuesMembers = () => {
        handleModalhide();
        setFormVenueMembers({
            ...formVenueMembers,
            isVisible: true
        });
    }

    const handleModalHideFormVenuesMembers = () => {
        handleModalShow(nighspotID);
        setFormVenueMembers({
            ...formVenueMembers,
            isVisible: false
        });
    }




    const handlerDeleteUserAccessConfirmation = (param) => {
        handleShowModalConfirmation(param)
    }

    const handlerDeleteUserAccess = async (id) => {
        console.log(id);
        let request = await UserAccessManagerRequests.deleteUsersAccess({ id: id });
        if (request) {
            if (request.status) {
                handleHideModalConfirmation();
                setRefreshGrid(1);
            } else {
                toast.error(request.errors, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
                handleHideModalConfirmation();
            }
        }
    }

    useEffect(async () => {
        if (show) {
            setNightspotID(id);
            let info = await UserAccessManagerRequests.getUsersAccessList({ id: id });
            if (info && info.status) {
                setState(info.data)
            }
        }
    }, [show, refreshGrid])



    return (<>
        <Modal
            show={show}
            onHide={handleModalhide}

        >
            <Modal.Header closeButton>
                <Modal.Title>Gerir acesso dos utilizadores</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className='row'>
                    <div className='col-12 mb-3'>
                        <button className='btn btn-primary float-end' onClick={handleModalShowFormVenuesMembers}>
                            <i className="fa-solid fa-plus me-2"></i>Adicionar novo utilizador
                        </button>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 event-list-table'>
                        <Table
                            columns={columns}
                            data={serializeRowsColums()}
                            currentPage={1}
                            itemsPerPage={10}
                            totalItems={state.length}
                        />
                    </div>
                </div>


            </Modal.Body>

            <Modal.Footer bsPrefix="modal-footer modal-button-row">
                <div className='row'>
                    <div className='col-12'>
                        <button className='btn btn-secondary float-end' onClick={handleModalhide}>
                            Fechar
                        </button>
                    </div>
                </div>

            </Modal.Footer>
        </Modal>
        <ModalConfirmation
            show={modalConfirmationState.isVisible}
            param={modalConfirmationState.param}
            handleModalhide={handleHideModalConfirmation}
            handleModalConfirm={(param) => handlerDeleteUserAccess(param)}
            text="Têm a certeza que deseja eliminar este registo?"
        />
        {/* <ToastContainer /> */}
        <UserAccessManagerModal
            id={nighspotID}
            show={formVenueMembers.isVisible}
            handleModalShow={() => handleModalShowFormVenuesMembers()}
            handleModalhide={() => handleModalHideFormVenuesMembers()}
        />
    </>
    );
}

export default UserAccessManagerListModal;